module.exports = __webpack_public_path__ + "img/theta_green.00dd80d4.png";